import { FC } from "react";
import { observer } from "mobx-react-lite";
import DefectUploadFileItem from "../defectUploadFileItem/defectUploadFileItem";

import styles from "./DefectUploadFiles.module.scss";

interface DefectUploadFilesProps {
  data: any;
}

const DefectUploadFiles: FC<DefectUploadFilesProps> = observer(({ data }) => {
  return (
    <>
      <div>
        <p className={styles.defectUploadTitle}>Вложенные файлы</p>
        <div className={styles.defectUploadFiles}>
          {data.files &&
            data.files.map((file) => (
              <DefectUploadFileItem key={file.id} file={file} />
            ))}
        </div>
      </div>
    </>
  );
});

export default DefectUploadFiles;
